import { BOARD_HOURS, HOUR_WIDTH } from '../../../shared/lib/schedule';

/**
 * The hour gridlines inside a row. Drawn at the same offsets as `BoardTimeAxis`'s labels, so a
 * block's left edge and its hour read as the same position.
 */
export const BoardHourGrid = () => (
  <>
    {BOARD_HOURS.slice(0, -1).map((hour, i) => (
      <div
        key={hour}
        className="absolute bottom-0 top-0 border-l border-gray-100"
        style={{ left: i * HOUR_WIDTH }}
        aria-hidden
      />
    ))}
  </>
);
